<template>
  <MainView></MainView>
</template>

<script setup>
import MainView from './views/MainView.vue'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { isPWA } from '@/utils/isPwa'
import { syncOfflineActivity } from '@/utils/offlineSync'

const router = useRouter()

onMounted(() => {
  window.addEventListener('online', syncOfflineActivity);
  syncOfflineActivity();

  if (isPWA()) {
    const token = localStorage.getItem('token')
    const currentPath = window.location.pathname;

    // Solo redirigir si el usuario entra a la ruta raíz para no sobreescribir /success
    if (currentPath === '/' || currentPath === '/index.html') {
      if (!token || token === 'undefined' || token === '') {
        router.replace('/login')
      } else {
        router.replace('/home')
      }
    }
  }
})
</script>
